<div class="inv-action-row">
  <div class="inv-action-col">
   <button [ngClass]="inventoryButtonClass" (click)="checkTakeInventory()" [disabled]="inventoryStatus === 'loading'" #inventoryBtn>
      {{ inventoryButtonText }}
      <span *ngIf="inventoryStatus === 'loading'" class="inv-spinner inv-spinner-large"></span>
    </button>
    <div class="inv-action-response">
      <table *ngIf="listProductData?.errors && listProductData.errors.length" class="inv-error-table">
        <thead>
          <tr>
            <th>Product</th>
            <th>Error</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let err of listProductData.errors">
            <td>{{ err.product }}</td>
            <td>{{ err.error }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="inv-action-col">
     <button class="theme-button" (click)="onFetchListProductClick(inventoryBtn)" [disabled]="loadingListProduct">
      Fetch listproduct
      <span *ngIf="loadingListProduct" class="inv-spinner"></span>
    </button>
    
  </div>
</div>
<div class="inv-action-row">
  <div class="inv-action-col">
    <!-- <button class="theme-button" (click)="fetchWsPath()" [disabled]="!wsPath || loadingWsPath">
      wspath
      <span *ngIf="loadingWsPath" class="inv-spinner"></span>
    </button> -->
    <div class="inv-action-response">
    <button *ngIf="wsPathData" [cdkCopyToClipboard]="wsPathData" title="Copy to clipboard">
      <span class="material-icons" style="vertical-align: middle;">content_copy</span>
    </button>
    <pre *ngIf="wsPathData">{{ wsPathData }}</pre>
  </div>
  </div>
  <div class="inv-action-col">
    <!-- <button class="theme-button" (click)="fetchWsPath2()" [disabled]="!wsPath2 || loadingWsPath2">
      wspath2
      <span *ngIf="loadingWsPath2" class="inv-spinner"></span>
    </button> -->

    <div class="inv-action-response">
          <button *ngIf="wsPath2Data" [cdkCopyToClipboard]="wsPath2Data" title="Copy to clipboard">
      <span class="material-icons" style="vertical-align: middle;">content_copy</span>
    </button>
      <pre *ngIf="wsPath2Data">{{ wsPath2Data }}</pre>
    </div>
  </div>
</div>
